"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyDev_mode_Construction_Visualisation = void 0;
// General import
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyDev_mode_Construction_Visualisation = (data, set_data, mode_selection) => {
    return react_1.default.createElement(react_bootstrap_1.ButtonGroup, { key: '2' },
        react_1.default.createElement(react_bootstrap_1.Button, { variant: (data.static_sankey) ? 'success' : 'outline-success', onClick: () => {
                data.accordeonToShow = ['Vis', 'Leg'];
                mode_selection.current = 's';
                data.static_sankey = true;
                set_data(Object.assign({}, data));
            } }, "Visualisation"),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: (data.static_sankey) ? 'outline-warning' : 'warning', onClick: () => {
                data.static_sankey = false;
                set_data(Object.assign({}, data));
            } }, "Construction"));
};
exports.SankeyDev_mode_Construction_Visualisation = SankeyDev_mode_Construction_Visualisation;
